import { ReactNode } from 'react'

import moment from 'moment'

import { Person } from '../../../libs/user/Person'

import { getSvgError } from '../../../libs/ui/icons/svg'

import People from '../People'

import { FisicaType, FisicaState, PeopleProps, getPeopleAddress } from '../PeopleSlice'
import { ContractorType } from '../contractor/Contractor'

import { getProfessioni, getSesso, getStati } from '../../../libs/initialization/remoteInits'

import PersonForm from '../person/PersonForm'
import SelectPeople from './SelectPeople'

import { isNotValiDataNascita, DATE_FORMAT } from '../../../libs/validation/dateValidation'
import { 
    EMAIL_PATTERN, PHONE_NUMBER_PATTERN, NAMES_PATTERN, STREET_ADDRES_PATTERN,
    isValid, isEmpty, isValidCityName
} from "../../../libs/validation/stringRegex"

interface GenericPeopleProps extends PeopleProps<FisicaType> {
    contractor: ContractorType
    peopleRole: string
    error?: string | undefined
}

class GenericPeople extends People<GenericPeopleProps, FisicaState> {

    constructor (props: any) {
        super(props)

        const other = this.props.people

        const address = getPeopleAddress (
            other?.street,
            other?.street_number,
            other?.zip,
            other?.city,
            other?.indirizzoResidenza_SedeLegale
        )

        this.state = {
            profList: undefined,
            sessoList: undefined,
            statiList: undefined,

            tipoPersona: 'fisica',
            
            natoInItalia: (other?.natoInItalia === undefined)
                ? undefined
                : (other?.natoInItalia || Number(other?.stato_nascita) === 13),
            nome: other?.nome,
            cognome: other?.cognome,
            email: other?.email,
            cellulare: other?.cellulare,

            indirizzoResidenza_SedeLegale: address,
            street: other?.street,
            street_number: other?.street_number,
            zip: other?.zip,
            city: other?.city,

            is_manual_address: false,

            sesso: other?.sesso,
            data_nascita: other?.data_nascita,
            stato_nascita: other?.stato_nascita,
            comune_nascita: other?.comune_nascita,
            professione: other?.professione,
            
            selectPeopleId: other?.selectPeopleId,

            tipoPersonaError: undefined,
            nomeError: undefined,
            cognomeError: undefined,
            emailError: undefined,
            cellulareError: undefined,
            natoInItaliaError: undefined,
            sessoError: undefined,
            data_nascitaError: undefined,
            stato_nascitaError: undefined,
            comune_nascitaError: undefined,
            indirizzoError: undefined,
            streetError: undefined,
            street_numberError: undefined,
            zipError: undefined,
            cityError: undefined,
            professioneError: undefined,
            selectPeopleIdError: undefined,
        }

        // bind
        this.updateEmail = this.updateEmail.bind(this)
        this.updateCellulare = this.updateCellulare.bind(this)
        this.updateName = this.updateName.bind(this)
        this.updateCognome = this.updateCognome.bind(this)
        this.updateNatoInItalia = this.updateNatoInItalia.bind(this)
        this.updateSesso = this.updateSesso.bind(this)
        this.updateData_nascita = this.updateData_nascita.bind(this)
        this.updateStato_nascita = this.updateStato_nascita.bind(this)
        this.updateComune_nascita = this.updateComune_nascita.bind(this)
        this.updateProfessione = this.updateProfessione.bind(this)
        this.updateIndirizzo = this.updateIndirizzo.bind(this)
        this.setIndirizzo = this.setIndirizzo.bind(this)
        this.updateStreet = this.updateStreet.bind(this)
        this.updateStreet_number = this.updateStreet_number.bind(this)
        this.updateZip = this.updateZip.bind(this)
        this.updateCity = this.updateCity.bind(this)
        this.updateAllAddressParts = this.updateAllAddressParts.bind(this)
        this.updateIsManualAddress = this.updateIsManualAddress.bind(this)
        this.updateSelectedPeople = this.updateSelectedPeople.bind(this)
        this.updateUserData = this.updateUserData.bind(this)
        this.getValueForGender = this.getValueForGender.bind(this)
        this.getValueForCountry = this.getValueForCountry.bind(this)
        this.manageExpiredSession = this.manageExpiredSession.bind(this)
        this.updateProfList = this.updateProfList.bind(this)
        this.updateSessoList = this.updateSessoList.bind(this)
        this.updateStatiList = this.updateStatiList.bind(this)
        this.clearNomeError = this.clearNomeError.bind(this)
        this.clearCognomeError = this.clearCognomeError.bind(this)
        this.clearEmailError = this.clearEmailError.bind(this)
        this.clearCellulareError = this.clearCellulareError.bind(this)
        this.clearNatoInItaliaError = this.clearNatoInItaliaError.bind(this)
        this.clearSessoError = this.clearSessoError.bind(this)
        this.clearData_nascitaError = this.clearData_nascitaError.bind(this)
        this.clearStato_nascitaError = this.clearStato_nascitaError.bind(this)
        this.clearComune_nascitaError = this.clearComune_nascitaError.bind(this)
        this.clearIndirizzoError = this.clearIndirizzoError.bind(this)
        this.clearStreetError = this.clearStreetError.bind(this)
        this.clearStreet_numberError = this.clearStreet_numberError.bind(this)
        this.clearZipError = this.clearZipError.bind(this)
        this.clearCityError = this.clearCityError.bind(this)
        this.clearProfessioneError = this.clearProfessioneError.bind(this)
        this.clearselectPeopleIdError = this.clearselectPeopleIdError.bind(this)

        this.updateStateFromPerson = this.updateStateFromPerson.bind(this)
        this.setErrorsList = this.setErrorsList.bind(this)
        this.checkUpdateStateWithError = this.checkUpdateStateWithError.bind(this)
        this.voidFunction = this.voidFunction.bind(this)
    }

    componentDidUpdate(prevProps: Readonly<GenericPeopleProps>, prevState: Readonly<FisicaState>, snapshot?: any): void {
        if ( this.checkUpdateStateWithError( this.props.error ) ) {
            this.setErrorsList ( this.props.error )
        }
    }

    componentDidMount (): void {
        if (this.props.user !== undefined) {
            this.updateUserData ()
        }
        
        // inizializzo le professioni
        if (this.state.profList === undefined) {
            getProfessioni( this.updateProfList, this.manageExpiredSession )
        }
        // inizializzo i sessi
        if (this.state.sessoList === undefined) {
            getSesso( this.updateSessoList, this.manageExpiredSession )
        }
        // inizializzo gli stati
        if (this.state.statiList === undefined) {
            getStati( this.updateStatiList, this.manageExpiredSession )
        }
    }
    
    render(): ReactNode {
        const contractor = this.props.contractor

        const isLogged = this.props.user !== undefined

        const hasSelectionError = this.state.selectPeopleId === undefined
        const selectedId = (!isLogged || hasSelectionError) ? undefined : this.state.selectPeopleId

        this.updateSelectedPeople ( selectedId )

        return (
            <div className='col-12 mt-4'>
                { contractor !== undefined && contractor.tipoPersona === 'fisica' &&
                    <>
                        { (isLogged)
                            ?   <>
                                    <p className={hasSelectionError ? 'mt-2 is-invalid' : 'mt-2'}>
                                        <strong>
                                            {hasSelectionError && getSvgError()}
                                            Seleziona il {this.props.peopleRole}
                                        </strong>
                                    </p>
                                    <SelectPeople 
                                        value={selectedId}

                                        contractor={contractor}
                                        peopleList={this.props.user?.people}
                                        profList={this.state.profList}
                                        statiList={this.state.statiList}

                                        callback={this.updateStateFromPerson}
                                        updateUserCallBack={this.updateUserData}
                                        expiredSessionCallbak={this.manageExpiredSession}

                                        peopleRole={this.props.peopleRole}
                                    />
                                </>
                            :   <>
                                    <h3>Informazioni sul proprietario</h3>
                                    <PersonForm
                                        nome={this.state.nome}
                                        cognome={this.state.cognome}

                                        sesso={this.state.sesso}
                                        dataNascita={this.state.data_nascita}
                                        natoInItalia={this.state.natoInItalia}
                                        stato_nascita={this.state.stato_nascita}
                                        comune_nascita={this.state.comune_nascita}
                                        professione={this.state.professione}

                                        indirizzoResidenza={this.state.indirizzoResidenza_SedeLegale}
                                        street={this.state.street}
                                        street_number={this.state.street_number}
                                        zip={this.state.zip}
                                        city={this.state.city}

                                        is_manual_address={this.state.is_manual_address}
                                        updateManualSelectionCallBack={this.updateIsManualAddress}

                                        updateName={this.updateName}
                                        updateCognome={this.updateCognome}
                                        updateSesso={this.updateSesso}
                                        updateDataNascita={this.updateData_nascita}
                                        updateNatoInItalia={this.updateNatoInItalia}
                                        updateStatoNascita={this.updateStato_nascita}
                                        updateComuneNascita={this.updateComune_nascita}

                                        updateProfessione={this.updateProfessione}

                                        updateIndirizzo={this.updateIndirizzo}
                                        updateStreet={this.updateStreet}
                                        updateStreet_number={this.updateStreet_number}
                                        updateZip={this.updateZip}
                                        updateCity={this.updateCity}
                                        updateAllAddressParts={this.updateAllAddressParts}
                                        
                                        nomeError={this.state.nomeError}
                                        cognomeError={this.state.cognomeError}

                                        natoInItaliaError={this.state.natoInItaliaError}
                                        sessoError={this.state.sessoError}
                                        dataNascitaError={this.state.data_nascitaError}
                                        statoError={this.state.stato_nascitaError}
                                        comuneError={this.state.comune_nascitaError}
                                        
                                        indirizzoResidenzaError={this.state.indirizzoError}
                                        streetError={this.state.streetError}
                                        street_numberError={this.state.street_numberError}
                                        zipError={this.state.zipError}
                                        cityError={this.state.cityError}

                                        profeError={this.state.professioneError}
                                        
                                        profList={this.state.profList}
                                        statiList={this.state.statiList}

                                        expiredSessionCallbak={this.props.expiredSessionCallbak}

                                        isInsert={true}

                                        hideEmail={true} // sarà quella del contraente
                                        email={contractor.email}
                                        updateEmail={this.voidFunction}

                                        hideCellulare={true} // sarà quello del contraente
                                        cellulare={contractor.cellulare}
                                        updateCellulare={this.voidFunction}
                                    />
                                </>
                        }
                    </>
                }   
            </div>
        )   
    }

    // privati
    private updateStateFromPerson (selectId: string) {
        if ( this.props.user?.people ) {
            let person: Person | undefined

            (this.props.user.people).forEach ( p => {
                if (p.id === selectId) {
                    person = p
                }
            })

            const address = (
                person?.address &&
                person?.addressNumber &&
                person?.postalCodeOfResidence &&
                person?.cityOfResidence
            )   
                ? person?.address + ', ' + person?.addressNumber + ', ' + person?.postalCodeOfResidence + ' ' + person?.cityOfResidence?.id + ', ITALIA'
                : person?.address

            if (person) {
                this.setState({
                    tipoPersona: 'fisica',
                    
                    email: (person.email ?? this.props.contractor.email) ?? this.props.user.email,
                    cellulare: (person.phone ?? this.props.contractor.cellulare) ?? this.props.user.phone,

                    nome: person.name,
                    cognome: person.surname,
                    
                    sesso: this.getValueForGender( person.gender ),
                    data_nascita: moment(person.dateOfBirth).format(DATE_FORMAT),

                    natoInItalia: (person?.bornInItaly || Number(person?.countryOfBirth?.id) === 13),
                    stato_nascita: this.getValueForCountry( person ),
                    comune_nascita: person.cityOfBirth?.id,
                    indirizzoResidenza_SedeLegale: address,

                    professione: person.profession,
                    
                    selectPeopleId: selectId
                },
                () => {
                    this.props.updatePeopleCallback(
                        this.getStateAsContractor()
                    )
                }
            )
            }
        }
    }

    private setErrorsList (error: string | undefined) {
        let nextErrorList : any = {
            nomeError: undefined,
            cognomeError: undefined,
            emailError: undefined,
            cellulareError: undefined,
            natoInItaliaError: undefined,
            sessoError: undefined,
            data_nascitaError: undefined,
            stato_nascitaError: undefined,
            comune_nascitaError: undefined,
            indirizzoError: undefined,
            streetError: undefined,
            street_numberError: undefined,
            zipError: undefined,
            cityError: undefined,
            professioneError: undefined,
            selectPeopleIdError: undefined,
        }

        if (error === 'PEOPLE_SELECTION') {
            nextErrorList.selectPeopleIdError = 'Valore non valido'
        }
        else if (error === 'PEOPLE_' || error === 'PEOPLE_NAME') {
            nextErrorList.nomeError = 'Valore non valido'
        }
        else if (error === 'PEOPLE_SURNAME') {
            nextErrorList.cognomeError = 'Valore non valido'
        }
        else if (error === 'PEOPLE_GENDER') {
            nextErrorList.sessoError = 'Valore non valido'
        }
        else if (error === 'PEOPLE_BIRTHDATE') {
            nextErrorList.data_nascitaError = 'Valore non valido'
        }
        else if (error === 'PEOPLE_BORN_IN_ITALY') {
            nextErrorList.natoInItaliaError = 'Valore non valido'
        }
        else if (error === 'PEOPLE_COUNTRY_OF_BIRTH') {
            nextErrorList.stato_nascitaError = 'Valore non valido'
        }
        else if (error === 'PEOPLE_CITY_OF_BIRTH') {
            nextErrorList.comune_nascitaError = 'Valore non valido'
        }
        
        else if (error === 'PEOPLE_ADDRESS') {
            nextErrorList.indirizzoError = 'Valore non valido'
        }
        else if (error === 'PEOPLE_STREET') {
            nextErrorList.streetError = 'Valore non valido'
        }
        else if (error === 'PEOPLE_STREET_NUMBER') {
            nextErrorList.street_numberError = 'Valore non valido'
        }
        else if (error === 'PEOPLE_CITY') {
            nextErrorList.zipError = 'Valore non valido'
        }
        else if (error === 'PEOPLE_ZIP') {
            nextErrorList.cityError = 'Valore non valido'
        }
        else if (error === 'PEOPLE_EMAIL') {
            nextErrorList.emailError = 'Valore non valido'
        }
        else if (error === 'PEOPLE_PHONE') {
            nextErrorList.cellulareError = 'Valore non valido'
        }
        else if (error === 'PEOPLE_PROFESSION') {
            nextErrorList.professioneError = 'Valore non valido'
        }

        this.setState ( nextErrorList )
    }

    private checkUpdateStateWithError (error: string | undefined) {
        return (error === 'PEOPLE_TIPO_PERSONA' && this.state.tipoPersonaError === undefined  && isEmpty(this.state.tipoPersona)) ||
                (error === 'PEOPLE_SELECTION' && this.state.selectPeopleIdError === undefined  && isEmpty(this.state.selectPeopleId)) ||
                ((error === 'PEOPLE_' || error === 'PEOPLE_NAME') && this.state.nomeError === undefined  && isEmpty(this.state.nome)) ||
                (error === 'PEOPLE_SURNAME' && this.state.cognomeError === undefined  && isEmpty(this.state.cognome)) ||
                (error === 'PEOPLE_GENDER' && this.state.sessoError === undefined  && this.state.sesso === undefined) ||
                (error === 'PEOPLE_BIRTHDATE' && this.state.data_nascitaError === undefined  && isEmpty(this.state.data_nascita)) ||
                (error === 'PEOPLE_BORN_IN_ITALY' && this.state.natoInItaliaError === undefined  && this.state.natoInItalia === undefined) ||
                (error === 'PEOPLE_COUNTRY_OF_BIRTH' && this.state.stato_nascitaError === undefined  && this.state.stato_nascita === undefined) ||
                (error === 'PEOPLE_CITY_OF_BIRTH' && this.state.comune_nascitaError === undefined  && isEmpty(this.state.comune_nascita)) ||
                (error === 'PEOPLE_ADDRESS' && this.state.indirizzoError === undefined  && isEmpty(this.state.indirizzoResidenza_SedeLegale)) ||
                (error === 'PEOPLE_STREET' && this.state.streetError === undefined  && isEmpty(this.state.street)) ||
                (error === 'PEOPLE_STREET_NUMBER' && this.state.street_numberError === undefined  && isEmpty(this.state.street_number)) ||
                (error === 'PEOPLE_CITY' && this.state.zipError === undefined  && isEmpty(this.state.zip)) ||
                (error === 'PEOPLE_ZIP' && this.state.cityError === undefined  && isEmpty(this.state.city)) ||
                (error === 'PEOPLE_EMAIL' && this.state.emailError === undefined  && isEmpty(this.state.email)) ||
                (error === 'PEOPLE_PHONE' && this.state.cellulareError === undefined  && isEmpty(this.state.cellulare)) ||
                (error === 'PEOPLE_PROFESSION' && this.state.professioneError === undefined  && this.state.professione === undefined)
    }

    private voidFunction () {}
}

export default GenericPeople

export function getEmptyGenericPeople () : FisicaState {
    return {
        tipoPersona: 'fisica',

        nome: undefined,
        cognome: undefined,
        email: undefined,
        cellulare: undefined,

        indirizzoResidenza_SedeLegale: undefined,
        street: undefined,
        street_number: undefined,
        zip: undefined,
        city: undefined,

        is_manual_address: false,

        natoInItalia: undefined,
        sesso: undefined,
        data_nascita: undefined,
        stato_nascita: undefined,
        comune_nascita: undefined,
        professione: undefined,

        sessoList: undefined,
        statiList: undefined,
        profList: undefined,

        selectPeopleId: undefined,
    }
}

export function isValidGenericPeople (c: FisicaType) {

    if (c.selectPeopleId !== undefined) {
        return true
    }

    return (
        isValid (c.nome, NAMES_PATTERN) && 
        isValid (c.cognome, NAMES_PATTERN) && 
        isValid (c.cellulare, PHONE_NUMBER_PATTERN) &&
        isValid (c.email, EMAIL_PATTERN) &&
        // sesso
        c.sesso !== undefined &&
        // stato nascita
        c.stato_nascita !== undefined &&
        // comune nascita
        (
            (
                c.stato_nascita === 13 && // italia
                isValidCityName(c.comune_nascita)
            ) ||
            (
                c.stato_nascita !== 13 && // stato estero
                c.comune_nascita === undefined
            )
        ) &&
        !isNotValiDataNascita(c.data_nascita) &&
        !isEmpty(c.professione) &&
        isValid (c.indirizzoResidenza_SedeLegale, STREET_ADDRES_PATTERN)
    )
    
}

export function getGenericPeopleError (c: FisicaType, type: string, isLogged: boolean) {
    if (isLogged && c.selectPeopleId === undefined)  {
        return type + '_SELECTION'
    } 
    else {
        if ( isEmpty(c.nome) ) {
            return type + '_NAME'
        }
        else if ( isEmpty(c.cognome) ) {
            return type + '_SURNAME'
        }

        else if ( isEmpty(c.sesso?.toString()) ) {
            return type + '_GENDER'
        }
        else if ( isEmpty(c.data_nascita) || isNotValiDataNascita(c.data_nascita) ) {
            return type + '_BIRTHDATE'
        }
        else if ( c.natoInItalia === undefined ) {
            return type + '_BORN_IN_ITALY'
        }
        else if ( isEmpty(c.stato_nascita?.toString()) ) {
            return type + '_COUNTRY_OF_BIRTH'
        }
        else if ( c.natoInItalia === true && !isValidCityName(c.comune_nascita) ) {
            return type + '_CITY_OF_BIRTH'
        }

        else if (!isValid (c.indirizzoResidenza_SedeLegale, STREET_ADDRES_PATTERN) ) {
            return type + '_ADDRESS'
        }

        // se loggato..
        else if ( !isLogged && isEmpty(c.city) ) {
            return type + '_CITY'
        }
        else if ( !isLogged && isEmpty(c.zip) ) {
            return type + '_ZIP'
        }
        else if ( !isLogged && isEmpty(c.street) ) {
            return type + '_STREET'
        }
        else if ( !isLogged && isEmpty(c.street_number) ) {
            return type + '_STREET_NUMBER'
        }

        else if ( isEmpty(c.professione) ) {
            return type + '_PROFESSION'
        }
        
    }

    return undefined
}

export function getGenericPeopleForSubmit (other: FisicaType | undefined, contractor?: ContractorType) {
    const address = getPeopleAddress(
        other?.street,
        other?.street_number,
        other?.zip,
        other?.city,
        other?.indirizzoResidenza_SedeLegale
    )

    return {
        nome: other?.nome,
        cognome: other?.cognome,
        email: other?.email ?? contractor?.email,
        telefono: other?.cellulare ?? contractor?.cellulare,

        indirizzoResidenza_SedeLegale: address,
        
        sesso: other?.sesso,
        dataNascita: other?.data_nascita,
        nazionalita: other?.stato_nascita,
        comuneNascita: other?.comune_nascita,
        professione: other?.professione,

        selectPeopleId: other?.selectPeopleId
    }
}